import { gql, useQuery } from '@apollo/client';
import { useParams } from 'react-router';
import { useState } from 'react';
import styled from 'styled-components';
import { PanelSection } from '../SidePanel';
import { WrappedNameInput } from '../left-menu/menu-components';

const MaxWidthDiv = styled.div`
  max-width: 100px;
  flex-shrink: 0; // Don't let the title squish the image
`;

const PreviewTitleQuery = gql`
  query PreviewTitleQuery($farmId: ID!) {
    farm(farmId: $farmId) {
      id
      name
      team {
        id
        signedUrl
      }
    }
  }
`;

const useTitleInfo = () => {
  const { farmId } = useParams();
  const { data } = useQuery(PreviewTitleQuery, { variables: { farmId } });
  const { name } = data?.farm || {};
  const { signedUrl } = data?.farm?.team || {};
  const [title, setTitle] = useState();
  return [
    <PanelSection className="d-flex align-items-center border-bottom-0 pb-0">
      {signedUrl && (
        <MaxWidthDiv>
          <img className="pr-2" src={signedUrl} height="60" alt="Team logo" />
        </MaxWidthDiv>
      )}
      <WrappedNameInput
        className="font-large"
        name={title || name}
        update={setTitle}
      />
    </PanelSection>,
  ];
};

export default useTitleInfo;
